import withMetric from 'containers/withMetric'

const metricData = (props) => {
  const { skillGroupId, skillId } = props
  return { skillGroupId, skillId }
}

export default withMetric('skillView', metricData)
